import Vue from 'vue';
import Router from 'vue-router';
import ChatPage from '@/components/Chat.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'ChatPage',
    component: ChatPage
  }
];

const router = new Router({
  mode: 'history',
  routes
});

export default router;

